import { put, select } from 'redux-saga/effects';

import * as AppActions from '../../../actions';
import * as AppConstants from '../../../constants';
import { getInDomain } from '../../../domains/externalUtils';
import Logger from '../../../tools/Logger';
import * as AppUtils from '../../../utils';

const log = Logger.child({
  component: 'mediator/openSearch',
});

export function* openSearch(action) {
  const { searchTerm, searchType, searchFilter, routeEntry } = action.data;
  const lastSearchTerm = yield select(
    getInDomain('searchT3.selectors.selectMainSearchTerm', () => ''),
  );

  if (routeEntry && lastSearchTerm !== searchTerm) {
    AppUtils.Time.markTimeAtMomentForQuery(
      AppConstants.App.SearchTriggerMarks.SEARCH_STATS_ROUTE_CHANGE,
      searchTerm,
    );
  }

  log.debug('showing search unification in openSearch useCase worker');
  const searchTermUpdate = getInDomain('searchT3.actions.searchTermUpdate');

  yield put(
    searchTermUpdate({
      searchTerm,
      searchType,
      searchFilter,
    }),
  );

  const isMainSearchActive = yield select(AppUtils.UIState.getIsMainSearchActive);
  if (isMainSearchActive) {
    return;
  }

  const searchUIStateUpdate = getInDomain('searchT3.actions.searchUIStateUpdate');
  yield put(
    searchUIStateUpdate({
      active: true,
      searchType,
    }),
  );
  if (searchType === getInDomain('searchT3.constants.SearchKeys.MAIN_SEARCH')) {
    yield put(AppActions.Application.enterSearch());
  }
}
